import React, {Component} from 'react';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {Route, Switch} from 'react-router-dom';
import {ModalContainer, ModalRoute} from 'react-router-modal';
import {Helmet} from 'react-helmet';
import theme from './_Utilities/MuiTheme';
// Import sass
import './styles/css/swiper.min.css';
import './styles/App.css';
import './styles/Modals.css';
// Import Components
import NavigationHeader from './components/Headers/NavigationHeader';
import Footer from './components/Footer';

import LandingPage from './routes/LandingPage';
import ProjectsRouter from './routes/ProjectsRouter';
import SponsorsPage from './routes/SponsorsPage';
import TeamPage from './routes/TeamPage';
import CoursesPage from './routes/CoursesPage';

import GraduateModal from './routes/Modals/GraduateModal';
import VideoModal from './routes/Modals/VideoModal';
import GraduatesPage from './routes/GraduatesPage';
// Import Icons
import fontawesome from '@fortawesome/fontawesome';
import {
    faArrowLeft,
    faArrowRight,
    faDesktop,
    faEnvelope,
    faFile,
    faPlusCircle,
    faTimes
} from '@fortawesome/fontawesome-free-solid';
import {faBehanceSquare, faFacebook, faInstagram, faLinkedin, faMedium} from '@fortawesome/fontawesome-free-brands';

fontawesome.library.add(faFile, faDesktop, faEnvelope, faBehanceSquare, faFacebook, faLinkedin, faInstagram, faMedium, faTimes, faArrowRight, faArrowLeft, faPlusCircle);

class App extends Component {
    constructor() {
        super();

        this.state = {
            modalIsOpen: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <Helmet>
                    <title>D18 Graduate Exhibition</title>
                </Helmet>
                <div className='app'>
                    <NavigationHeader/>
                    {/*Routes*/}
                    <Switch>
                        <Route path={'/'} exact component={LandingPage}/>
                        <Route path={'/v/'} component={LandingPage}/>
                        <Route path={'/graduates'} component={GraduatesPage}/>
                        <Route path={'/projects'} component={ProjectsRouter}/>
                        <Route path={'/sponsors'} exact component={SponsorsPage}/>
                        <Route path={'/team'} component={TeamPage}/>
                        <Route path={'/courses'} exact component={CoursesPage}/>
                    </Switch>
                    {/*Modals*/}
                    <Switch>
                        <ModalRoute parentPath={'/graduates'} path={'/graduates/:unikey'} component={GraduateModal}/>
                        <ModalRoute parentPath={'/team'} path={'/team/:unikey'} component={GraduateModal}/>
                        <ModalRoute parentPath={'/'} path={'/v/promo'} component={VideoModal}/>
                    </Switch>
                    <Footer/>
                    <ModalContainer
                        onKeyPress={(event) => {
                                console.log(event)
                            if (event.key === 'Escape') {
                                this.closeModal();
                            }
                        }}
                        isOpen={this.state.modalIsOpen}
                        containerClassName={'modal__container'}
                        modalClassName={'modal'}
                        backdropClassName={'modal__backdrop'}
                        bodyModalOpenClassName={'modal--open'}
                        wrapperClassName={'modal__wrapper'}
                        modalInClassName={'modal--in'}
                        modalOutClassName={'modal--out'}
                        backdropInClassName={'modal__backdrop--in'}
                        backdropOutClassName={'modal__backdrop--out'}
                    />
                </div>
            </MuiThemeProvider>
        );
    }
}

export default App;
